import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row, Button, Table } from 'react-bootstrap';
import FormInputs from '../../Utils/FormInputs';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

// Customers table data
import CustomersTableData from "./marketing-customer-table-data.json";

export default function SendSms() {
    // datatable
    const [customersData] = useState(CustomersTableData);
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableMSend')) {
            $('#mainDatatableMSend').DataTable({
                dom: "flrtip",
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
        }
    }, []);

    const initialInputData = {
        select_template: '',
        compose_sms: '',
        preview_sms: '',
    }

    const [inputData, setInputData] = useState(initialInputData);
    const handleMrkSendSmsChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleMrkSendSmsSubmit = (e) => {
        e.preventDefault();
    };
    const mrkSendSmsRows = [
        {
            rowClass: 'justify-content-end',
            columns: [
                {
                    size: { sm: 6, md: 5, lg: 4, xl: 3 }, label: 'Select Template', type: 'select', name: 'select_template', id: 'selectTemplate', value: inputData.select_template, inputParentClass: 'custom-form-input-sm', errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
            ]
        },
        {
            columns: [
                { size: { lg: 6 }, label: 'Compose SMS', type: 'textarea', placeholder: 'Type compose sms...', name: 'compose_sms', formrow: '3', id: 'composeSms', value: inputData.compose_sms, errormsg: '', },
                { size: { lg: 6 }, label: 'Preview SMS', type: 'textarea', placeholder: 'Type preview sms...', name: 'preview_sms', formrow: '3', id: 'previewSms', value: inputData.preview_sms, errormsg: '', },
            ]            
        }
    ];
    const mrkSendSmsButtons = [
        { variant: "light", text: "Send All", },
        { variant: "light", text: "Send Selected", },
        { variant: "light", text: "Reset", },
    ];

    return (
        <>
            <Card.Title>Send SMS</Card.Title>
            <Card className='border shadow-none'>
                <Card.Body>
                    <FormInputs Buttons={mrkSendSmsButtons} rows={mrkSendSmsRows} handleInputChange={handleMrkSendSmsChange} handleSubmit={handleMrkSendSmsSubmit} />
                </Card.Body>
            </Card>
            <Card className='border shadow-none'>
                <Card.Body>
                    <div className="d-sm-flex justify-content-between align-items-center mb-3">
                        <Card.Title>Customers</Card.Title>
                        <div>
                            <Form className='d-sm-flex align-items-center '>
                                <Form.Select size="sm" className='me-sm-3 mb-sm-0 mb-3'>
                                    <option>Year to date(YTD)</option>
                                    <option value="1">All Time</option>
                                    <option value="2">Two</option>
                                </Form.Select>
                                <Form.Select size="sm">
                                    <option>All</option>
                                    <option value="1">Select One</option>
                                    <option value="2">Two</option>
                                </Form.Select>
                            </Form>
                        </div>
                    </div>

                    <Table responsive bordered className='table-nowrap' id='mainDatatableMSend'>
                        <thead className='table-light'>
                            <tr>
                                <th>
                                    <Form>
                                        {['checkbox'].map((type) => (
                                            <div key={`default-${type}`}>
                                                <Form.Check
                                                    type={type}
                                                    id={`default-Unchecked-${type}`}
                                                />
                                            </div>
                                        ))}
                                    </Form>
                                </th>
                                <th>S.no.</th>
                                <th>Contact</th>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customersData.map((data, i) =>
                                <tr key={i}>
                                    <td>
                                        <Form>
                                            {['checkbox'].map((type) => (
                                                <div key={`default-${type}`}>
                                                    <Form.Check
                                                        type={type}
                                                        id={`default-Unchecked-${type}`}
                                                    />
                                                </div>
                                            ))}
                                        </Form>
                                    </td>
                                    <td>{data.sNo}</td>
                                    <td>{data.contact}</td>
                                    <td>{data.name}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    )
}
